// asgains free-shipping progress bar — live updates on cart change.
// Listens for Dawn's cart-update lifecycle (fetch /cart/change|add|update)
// and refreshes all .asgains-shipping-bar elements without a page reload.

(function () {
  'use strict';

  const SELECTORS = {
    bar: '[data-shipping-bar]',
    fill: '[data-shipping-bar-fill]',
    text: '[data-shipping-bar-text]',
  };

  function formatMoney(cents) {
    var fmt = window.theme && window.theme.moneyFormat;
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      try { return Shopify.formatMoney(cents, fmt); } catch (e) {}
    }
    const major = (cents / 100).toFixed(2).replace(/\.00$/, '');
    const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EGP';
    return currency + ' ' + major;
  }

  function refreshBar(bar, totalCents) {
    const threshold = parseInt(bar.getAttribute('data-threshold'), 10) || 0;
    if (threshold <= 0) return;

    const remaining = threshold - totalCents;
    const pct = remaining <= 0 ? 100 : Math.min(100, Math.max(0, (totalCents * 100) / threshold));

    const fill = bar.querySelector(SELECTORS.fill);
    if (fill) {
      fill.style.transform = 'scaleX(' + (pct / 100) + ')';
      fill.setAttribute('data-progress', pct.toFixed(0));
    }

    const text = bar.querySelector(SELECTORS.text);
    if (text) {
      if (remaining <= 0) {
        text.innerHTML = '🎉 You unlocked <strong>FREE shipping</strong>!';
      } else {
        text.innerHTML =
          'Spend <strong>' + formatMoney(remaining) + '</strong> more for <strong>FREE shipping</strong>';
      }
    }
  }

  function refreshAllBars(totalCents) {
    document.querySelectorAll(SELECTORS.bar).forEach(function (bar) {
      refreshBar(bar, totalCents);
    });
  }

  function fetchAndRefresh() {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' },
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { refreshAllBars(cart.total_price || 0); })
      .catch(function () {});
  }

  // Subscribe to Dawn's cart lifecycle via PUB_SUB — the proper way, no fetch monkeypatching.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      var cart = event && event.cartData;
      if (cart && typeof cart.total_price === 'number') {
        refreshAllBars(cart.total_price);
      } else {
        fetchAndRefresh();
      }
    });
  }

  // Fallback: also listen for any custom cart DOM events the theme may dispatch.
  ['cart:updated', 'cart:refresh'].forEach(function (evt) {
    document.addEventListener(evt, fetchAndRefresh);
  });
})();
